function numberWithCommas(x) {
	return x.toString().replaceAll(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export default numberWithCommas;
